/* eslint-disable max-lines */
import { RESERVE_TYPES } from 'constants'

export default {
    account_rewards: {
        gold: null,
        credits: null,
    },
    clan_rewards: {
        superiority: {
            place: 199,
            gold: null,
            credits: null,
            reserves: [
                {
                    type: RESERVE_TYPES.ADDITIONAL_BRIEFING,
                    level: 12,
                    count: 30,
                },
            ],
            points_lack: null,
        },
        onslaught: {
            place: null,
            gold: null,
            credits: null,
            reserves: null,
            points_lack: null,
        },
        shooting: {
            place: 3,
            gold: 15000,
            credits: 1000000,
            reserves: [
                {
                    type: RESERVE_TYPES.BATTLE_PAYMENTS,
                    level: 12,
                    count: 4,
                },
                {
                    type: RESERVE_TYPES.MILITARY_MANEUVERS,
                    level: 12,
                    count: 2,
                },
                {
                    type: RESERVE_TYPES.TACTICAL_TRAINING,
                    level: 12,
                    count: 12,
                },
                {
                    type: RESERVE_TYPES.ADDITIONAL_BRIEFING,
                    level: 12,
                    count: 30,
                },
            ],
            points_lack: null,
        },
        conscription: {
            place: null,
            gold: null,
            credits: null,
            reserves: null,
            points_lack: 1230,
        },
    },
    reserves_settings: {
        MILITARY_MANEUVERS: {
            bonus: {
                type: 'extra_free_xp',
                values: [
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '50%',
                        },
                        level: 1,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '50%',
                        },
                        level: 2,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '100%',
                        },
                        level: 3,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '100%',
                        },
                        level: 4,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '150%',
                        },
                        level: 5,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '150%',
                        },
                        level: 6,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '200%',
                        },
                        level: 7,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '200%',
                        },
                        level: 8,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '250%',
                        },
                        level: 9,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '250%',
                        },
                        level: 10,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '300%',
                        },
                        level: 11,
                        duration: 10800,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '500%',
                        },
                        level: 12,
                        duration: 14400,
                    },
                ],
            },
            conditions: [
                {
                    production_cost: 275,
                    production_time: 5,
                },
                {
                    production_cost: 650,
                    production_time: 20,
                },
                {
                    production_cost: 1100,
                    production_time: 60,
                },
                {
                    production_cost: 1700,
                    production_time: 300,
                },
                {
                    production_cost: 2500,
                    production_time: 1200,
                },
                {
                    production_cost: 3400,
                    production_time: 3600,
                },
                {
                    production_cost: 4400,
                    production_time: 7200,
                },
                {
                    production_cost: 5700,
                    production_time: 14400,
                },
                {
                    production_cost: 7500,
                    production_time: 28800,
                },
                {
                    production_cost: 8500,
                    production_time: 28800,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
            ],
            type: 'MILITARY_MANEUVERS',
        },
        HIGH_CAPACITY_TRANSPORT: {
            bonus: {
                type: 'extra_industrial_resource',
                values: [
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '5%',
                        },
                        level: 1,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '10%',
                        },
                        level: 2,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '15%',
                        },
                        level: 3,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '20%',
                        },
                        level: 4,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '30%',
                        },
                        level: 5,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '35%',
                        },
                        level: 6,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '40%',
                        },
                        level: 7,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '50%',
                        },
                        level: 8,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '55%',
                        },
                        level: 9,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '60%',
                        },
                        level: 10,
                        duration: null,
                    },
                    {
                        special_conditions: [
                            'X_level_only',
                        ],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '100%',
                        },
                        level: 11,
                        duration: null,
                    },
                    {
                        special_conditions: [
                            'X_level_only',
                        ],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '200%',
                        },
                        level: 12,
                        duration: null,
                    },
                ],
            },
            conditions: [
                {
                    production_cost: 5,
                    production_time: 5,
                },
                {
                    production_cost: 10,
                    production_time: 5,
                },
                {
                    production_cost: 20,
                    production_time: 5,
                },
                {
                    production_cost: 25,
                    production_time: 5,
                },
                {
                    production_cost: 40,
                    production_time: 5,
                },
                {
                    production_cost: 45,
                    production_time: 5,
                },
                {
                    production_cost: 50,
                    production_time: 5,
                },
                {
                    production_cost: 60,
                    production_time: 5,
                },
                {
                    production_cost: 70,
                    production_time: 5,
                },
                {
                    production_cost: 75,
                    production_time: 5,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
            ],
            type: 'HIGH_CAPACITY_TRANSPORT',
        },
        ADDITIONAL_BRIEFING: {
            bonus: {
                type: 'extra_crew_xp',
                values: [
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '25%',
                            clan_battles: '50%',
                        },
                        level: 1,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '25%',
                            clan_battles: '50%',
                        },
                        level: 2,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '50%',
                            clan_battles: '75%',
                        },
                        level: 3,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '50%',
                            clan_battles: '75%',
                        },
                        level: 4,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '75%',
                            clan_battles: '100%',
                        },
                        level: 5,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '75%',
                            clan_battles: '100%',
                        },
                        level: 6,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '100%',
                            clan_battles: '150%',
                        },
                        level: 7,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '100%',
                            clan_battles: '150%',
                        },
                        level: 8,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '150%',
                            clan_battles: '200%',
                        },
                        level: 9,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '150%',
                            clan_battles: '200%',
                        },
                        level: 10,
                        duration: 7200,
                    },
                    {
                        special_conditions: [
                            'X_level_only',
                        ],
                        battle_types: {
                            random_battles: '200%',
                            clan_battles: '300%',
                        },
                        level: 11,
                        duration: 7200,
                    },
                    {
                        special_conditions: [
                            'X_level_only',
                        ],
                        battle_types: {
                            random_battles: '300%',
                            clan_battles: '400%',
                        },
                        level: 12,
                        duration: 7200,
                    },
                ],
            },
            conditions: [
                {
                    production_cost: 275,
                    production_time: 5,
                },
                {
                    production_cost: 650,
                    production_time: 20,
                },
                {
                    production_cost: 1100,
                    production_time: 60,
                },
                {
                    production_cost: 1700,
                    production_time: 300,
                },
                {
                    production_cost: 2500,
                    production_time: 1200,
                },
                {
                    production_cost: 3400,
                    production_time: 3600,
                },
                {
                    production_cost: 4400,
                    production_time: 7200,
                },
                {
                    production_cost: 5700,
                    production_time: 14400,
                },
                {
                    production_cost: 7500,
                    production_time: 28800,
                },
                {
                    production_cost: 8500,
                    production_time: 28800,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
            ],
            type: 'ADDITIONAL_BRIEFING',
        },
        REQUISITION: {
            bonus: {
                type: 'extra_industrial_resource',
                values: [
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold: '5%',
                        },
                        level: 1,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold: '10%',
                        },
                        level: 2,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold: '15%',
                        },
                        level: 3,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold: '20%',
                        },
                        level: 4,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold: '30%',
                        },
                        level: 5,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold: '35%',
                        },
                        level: 6,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold: '40%',
                        },
                        level: 7,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold: '50%',
                        },
                        level: 8,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold: '55%',
                        },
                        level: 9,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold: '60%',
                        },
                        level: 10,
                        duration: null,
                    },
                    {
                        special_conditions: [
                            'X_level_only',
                        ],
                        battle_types: {
                            battle_for_stronghold: '100%',
                        },
                        level: 11,
                        duration: null,
                    },
                    {
                        special_conditions: [
                            'X_level_only',
                        ],
                        battle_types: {
                            battle_for_stronghold: '200%',
                        },
                        level: 12,
                        duration: null,
                    },
                ],
            },
            conditions: [
                {
                    production_cost: 90,
                    production_time: 5,
                },
                {
                    production_cost: 225,
                    production_time: 5,
                },
                {
                    production_cost: 400,
                    production_time: 5,
                },
                {
                    production_cost: 600,
                    production_time: 5,
                },
                {
                    production_cost: 1000,
                    production_time: 5,
                },
                {
                    production_cost: 1300,
                    production_time: 5,
                },
                {
                    production_cost: 1650,
                    production_time: 5,
                },
                {
                    production_cost: 2250,
                    production_time: 5,
                },
                {
                    production_cost: 2700,
                    production_time: 5,
                },
                {
                    production_cost: 3200,
                    production_time: 5,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
            ],
            type: 'REQUISITION',
        },
        BATTLE_PAYMENTS: {
            bonus: {
                type: 'extra_credits',
                values: [
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '5%',
                            clan_battles: '10%',
                        },
                        level: 1,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '5%',
                            clan_battles: '10%',
                        },
                        level: 2,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '10%',
                            clan_battles: '20%',
                        },
                        level: 3,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '10%',
                            clan_battles: '20%',
                        },
                        level: 4,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '15%',
                            clan_battles: '30%',
                        },
                        level: 5,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '15%',
                            clan_battles: '30%',
                        },
                        level: 6,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '20%',
                            clan_battles: '40%',
                        },
                        level: 7,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '20%',
                            clan_battles: '40%',
                        },
                        level: 8,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '25%',
                            clan_battles: '50%',
                        },
                        level: 9,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            random_battles: '30%',
                            clan_battles: '75%',
                        },
                        level: 10,
                        duration: 10800,
                    },
                    {
                        special_conditions: [
                            'X_level_only',
                        ],
                        battle_types: {
                            random_battles: '30%',
                            clan_battles: '100%',
                        },
                        level: 11,
                        duration: 7200,
                    },
                    {
                        special_conditions: [
                            'X_level_only',
                        ],
                        battle_types: {
                            random_battles: '30%',
                            clan_battles: '150%',
                        },
                        level: 12,
                        duration: 7200,
                    },
                ],
            },
            conditions: [
                {
                    production_cost: 275,
                    production_time: 5,
                },
                {
                    production_cost: 650,
                    production_time: 20,
                },
                {
                    production_cost: 1100,
                    production_time: 60,
                },
                {
                    production_cost: 1700,
                    production_time: 300,
                },
                {
                    production_cost: 2500,
                    production_time: 1200,
                },
                {
                    production_cost: 3400,
                    production_time: 3600,
                },
                {
                    production_cost: 4400,
                    production_time: 7200,
                },
                {
                    production_cost: 5700,
                    production_time: 14400,
                },
                {
                    production_cost: 7500,
                    production_time: 28800,
                },
                {
                    production_cost: 8500,
                    production_time: 28800,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
            ],
            type: 'BATTLE_PAYMENTS',
        },
        TACTICAL_TRAINING: {
            bonus: {
                type: 'extra_battle_xp',
                values: [
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '5%',
                        },
                        level: 1,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '5%',
                        },
                        level: 2,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '10%',
                        },
                        level: 3,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '10%',
                        },
                        level: 4,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '20%',
                        },
                        level: 5,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '20%',
                        },
                        level: 6,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '35%',
                        },
                        level: 7,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '35%',
                        },
                        level: 8,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '50%',
                        },
                        level: 9,
                        duration: 3600,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '50%',
                        },
                        level: 10,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '75%',
                        },
                        level: 11,
                        duration: 7200,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            all_battles: '100%',
                        },
                        level: 12,
                        duration: 7200,
                    },
                ],
            },
            conditions: [
                {
                    production_cost: 275,
                    production_time: 5,
                },
                {
                    production_cost: 650,
                    production_time: 20,
                },
                {
                    production_cost: 1100,
                    production_time: 60,
                },
                {
                    production_cost: 1700,
                    production_time: 300,
                },
                {
                    production_cost: 2500,
                    production_time: 1200,
                },
                {
                    production_cost: 3400,
                    production_time: 3600,
                },
                {
                    production_cost: 4400,
                    production_time: 7200,
                },
                {
                    production_cost: 5700,
                    production_time: 14400,
                },
                {
                    production_cost: 7500,
                    production_time: 28800,
                },
                {
                    production_cost: 8500,
                    production_time: 28800,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
            ],
            type: 'TACTICAL_TRAINING',
        },
        AIRSTRIKE: {
            bonus: {
                type: 'extra_industrial_resource',
                values: [
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '5%',
                        },
                        level: 1,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '10%',
                        },
                        level: 2,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '15%',
                        },
                        level: 3,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '20%',
                        },
                        level: 4,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '30%',
                        },
                        level: 5,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '35%',
                        },
                        level: 6,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '40%',
                        },
                        level: 7,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '50%',
                        },
                        level: 8,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '55%',
                        },
                        level: 9,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '60%',
                        },
                        level: 10,
                        duration: null,
                    },
                    {
                        special_conditions: [
                            'X_level_only',
                        ],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '100%',
                        },
                        level: 11,
                        duration: null,
                    },
                    {
                        special_conditions: [
                            'X_level_only',
                        ],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '200%',
                        },
                        level: 12,
                        duration: null,
                    },
                ],
            },
            conditions: [
                {
                    production_cost: 5,
                    production_time: 5,
                },
                {
                    production_cost: 10,
                    production_time: 5,
                },
                {
                    production_cost: 20,
                    production_time: 5,
                },
                {
                    production_cost: 25,
                    production_time: 5,
                },
                {
                    production_cost: 40,
                    production_time: 5,
                },
                {
                    production_cost: 45,
                    production_time: 5,
                },
                {
                    production_cost: 50,
                    production_time: 5,
                },
                {
                    production_cost: 60,
                    production_time: 5,
                },
                {
                    production_cost: 70,
                    production_time: 5,
                },
                {
                    production_cost: 75,
                    production_time: 5,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
            ],
            type: 'AIRSTRIKE',
        },
        ARTILLERY_STRIKE: {
            bonus: {
                type: 'extra_industrial_resource',
                values: [
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '5%',
                        },
                        level: 1,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '10%',
                        },
                        level: 2,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '15%',
                        },
                        level: 3,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '20%',
                        },
                        level: 4,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '30%',
                        },
                        level: 5,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '35%',
                        },
                        level: 6,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '40%',
                        },
                        level: 7,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '50%',
                        },
                        level: 8,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '55%',
                        },
                        level: 9,
                        duration: null,
                    },
                    {
                        special_conditions: [],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '60%',
                        },
                        level: 10,
                        duration: null,
                    },
                    {
                        special_conditions: [
                            'X_level_only',
                        ],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '100%',
                        },
                        level: 11,
                        duration: null,
                    },
                    {
                        special_conditions: [
                            'X_level_only',
                        ],
                        battle_types: {
                            battle_for_stronghold_and_sortie: '200%',
                        },
                        level: 12,
                        duration: null,
                    },
                ],
            },
            conditions: [
                {
                    production_cost: 5,
                    production_time: 5,
                },
                {
                    production_cost: 10,
                    production_time: 5,
                },
                {
                    production_cost: 20,
                    production_time: 5,
                },
                {
                    production_cost: 25,
                    production_time: 5,
                },
                {
                    production_cost: 40,
                    production_time: 5,
                },
                {
                    production_cost: 45,
                    production_time: 5,
                },
                {
                    production_cost: 50,
                    production_time: 5,
                },
                {
                    production_cost: 60,
                    production_time: 5,
                },
                {
                    production_cost: 70,
                    production_time: 5,
                },
                {
                    production_cost: 75,
                    production_time: 5,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
                {
                    production_cost: null,
                    production_time: null,
                },
            ],
            type: 'ARTILLERY_STRIKE',
        },
    },
}



// WEBPACK FOOTER //
// ./containers/ChallengesResults/mock.js